import React from 'react';
import styled from 'styled-components';
import { ReactComponent as InviteIcon } from 'images/v2/icons/svg/fill/svg/envelope.svg';
import { EpdLinks } from 'routes/EpdRoutes';
import { useHistory } from 'react-router-dom';

interface Props {
  count: number;
}

const NewInvitesButton: React.FC<Props> = ({ count }) => {
  const history = useHistory();

  return (
    <Button type="button" onClick={() => history.push(EpdLinks.userSettings('membership', 'invites'))}>
      <Left>
        <InviteIcon />
        <Text>New invites</Text>
      </Left>

      <Counter>{count}</Counter>
    </Button>
  );
};

const Button = styled.button`
  width: 262px;
  height: 40px;

  margin-bottom: 20px;
  padding: 0 16px;

  display: flex;
  justify-content: space-between;
  align-items: center;

  border: none;
  border-radius: 4px;

  background: ${(props) => props.theme.colors.secondaryLightGreen30};
  color: ${(props) => props.theme.colors.primaryGreen};

  cursor: pointer;
  transition: background-color 0.2s;

  &:hover {
    background: ${(props) => props.theme.colors.elementsFilledInput};
  }
`;

const Left = styled.div`
  display: flex;
  align-items: center;

  svg {
    width: 16px;
    height: 16px;
  }
`;

const Text = styled.span`
  margin-left: 16px;

  font-family: 'Inter';
  font-size: 16px;
  font-weight: 400;

  color: ${(props) => props.theme.colors.primaryGreen};
`;

const Counter = styled.span`
  font-family: 'Inter';
  font-size: 16px;
  font-weight: 700;

  color: ${(props) => props.theme.colors.primaryGreen};
`;

export default NewInvitesButton;
